// extracted by mini-css-extract-plugin
module.exports = {"header":"workers_header__3wZ8j","table":"workers_table__1zNxj","filters":"workers_filters__j4CKH","row":"workers_row__18S0H","submitBtns":"workers_submitBtns__VTWh5"};